export default {
  'cloak.ipacl.col.ip': 'IP/IP段',
  'cloak.ipacl.col.type': '类型',
  'cloak.ipacl.col.status': '状态',
  'cloak.ipacl.col.remark': '备注',
  'cloak.ipacl.col.action': '操作',
  'cloak.ipacl.whitelist': '白名单',
  'cloak.ipacl.blacklist': '黑名单',
  'cloak.ipacl.add': '添加',
  'cloak.ipacl.edit': '编辑',
  'cloak.ipacl.delete': '删除',
  'cloak.ipacl.deleteConfirm': '确定删除？',
  'cloak.ipacl.modal.edit': '编辑IP规则',
  'cloak.ipacl.modal.add': '添加IP规则',
  'cloak.ipacl.form.ipType': 'IP类型',
  'cloak.ipacl.form.filterType': '过滤状态',
  'cloak.ipacl.form.singleIp': '单个IP',
  'cloak.ipacl.form.singleIpExtra': '输入单个IP地址，如 192.168.1.1',
  'cloak.ipacl.form.singleIpPlaceholder': '单个IP（与IP段二选一）',
  'cloak.ipacl.form.ipStart': 'IP段起始',
  'cloak.ipacl.form.ipStartExtra': '输入IP段起始地址',
  'cloak.ipacl.form.ipStartPlaceholder': 'IP段起始（与单个IP二选一）',
  'cloak.ipacl.form.ipEnd': 'IP段结束',
  'cloak.ipacl.form.ipEndExtra': '输入IP段结束地址',
  'cloak.ipacl.form.ipEndPlaceholder': 'IP段结束',
  'cloak.ipacl.form.remark': '备注',
  'cloak.ipacl.form.remarkPlaceholder': '备注说明',
  'cloak.ipacl.form.cidr': 'CIDR',
  'cloak.ipacl.form.cidrExtra': '输入CIDR，如 192.168.1.0/24（自动展开为IP段）',
  'cloak.ipacl.form.cidrPlaceholder': 'CIDR（与单个IP/IP段三选一）',
  'cloak.ipacl.statusPlaceholder': '状态',
  'cloak.ipacl.msg.deleteOk': '删除成功',
  'cloak.ipacl.msg.deleteErr': '删除失败',
  'cloak.ipacl.msg.updateOk': '更新成功',
  'cloak.ipacl.msg.updateErr': '更新失败',
  'cloak.ipacl.msg.addOk': '添加成功',
  'cloak.ipacl.msg.addErr': '添加失败',
  'cloak.ipacl.import': '导入',
  'cloak.ipacl.import.title': '批量导入IP规则',
  'cloak.ipacl.import.upload': '拖拽 txt 文件到此处，或点击选择',
  'cloak.ipacl.import.format': '每行一条，支持 CIDR/单个IP/IP段(用-分隔)',
  'cloak.ipacl.import.selected': '已选择',
  'cloak.ipacl.import.reselect': '重新选择',
  'cloak.ipacl.import.preview': '预览',
  'cloak.ipacl.import.valid': '有效',
  'cloak.ipacl.import.invalid': '无效',
  'cloak.ipacl.import.formatError': '格式错误',
  'cloak.ipacl.import.dupSkip': '重复已跳过',
  'cloak.ipacl.import.success': '成功导入 {count} 条',
  'cloak.ipacl.import.fail': '导入失败',
  'cloak.ipacl.import.overLimit': '超过上限 {limit} 条',
  'cloak.ipacl.import.empty': '文件为空或无有效行',
  DOMAIN_VERIFY_REQUIRED: '域名需要先通过 NS 和注册商验证才能上线',
  'cloak.geo.title': '国家地区规则',
  'cloak.advanced.title': 'ASN 高级规则',
};
